import {useState} from 'react';

import {VisuallyHiddenLabel} from 'components/accessibility';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';

const AnnounceNewTitleOnPageChange = () => {
  const [title, setTitle] = useState(document.title);
  TitleChangeObserver(() =>
    setTitle(
      document.title
        ? intlFormatSingleMessage(LOCALIZED_TRANSLATIONS.VIEWING_PAGE, {page: document.title.split('|')[0].trim()})
        : ''
    )
  );
  if (!title) {
    return null;
  }
  return <VisuallyHiddenLabel aria-live="polite">{title}</VisuallyHiddenLabel>;
};

const TitleChangeObserver = (callback: Function) => {
  const titleNode = document.querySelector('title');
  if (!titleNode) {
    setTimeout(() => TitleChangeObserver(callback), 100);
    return;
  }
  new MutationObserver((mutations) => {
    callback();
  }).observe(titleNode, {subtree: true, characterData: true, childList: true});
};

const LOCALIZED_TRANSLATIONS = {
  VIEWING_PAGE: 'Viewing {page} page'
};

export default AnnounceNewTitleOnPageChange;
